module.exports = __webpack_public_path__ + "img/user.44601df0.svg";